import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";

/** Public venue cache is distinct from staff/booking operational details. */
export function usePublicFacility(facilityId: string | undefined) {
  return useQuery({
    queryKey: ["public-facility", facilityId],
    queryFn: () => facilityApi.getPublic(facilityId!),
    enabled: Boolean(facilityId),
  });
}
